export default {"src":"/login-app/[GIT_HASH]/_next/static/media/add.13a3b8e2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};